import {Injectable} from "@angular/core";
import {Http, Response} from "@angular/http";
import {UtilService} from "../util";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

@Injectable()
export class UserService {
  constructor(private http: Http, private utilService: UtilService) {
  }

  resendActivationEmail(userId: number) {
    let url = `/user/${userId}/resend`;
    return this.http
      .post(url, {})
      .map((res: Response) => res.json())
      .catch(this.utilService.handleError);
  }

  deactivateUser(userId: number) {
    let url = `/user/${userId}/deactivate`;
    return this.http
      .post(url, {})
      .map((res: Response) => res)
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/user/user.service.ts